// Every top message the web app shows, in one place: the same situation is worded the same way everywhere, and
// the wording can be read or changed here without hunting through the pages

// How long the short confirmations stay on screen, in seconds
export const SHORT_MESSAGE_SECONDS = 2;

// --- Connection -------------------------------------------------------------------------------------------------
export const NO_NETWORK_CONNECTIVITY = 'No data connection, please try again later';

// --- Generic ----------------------------------------------------------------------------------------------------
export const genericError = (description: string) => `There was an error: ${description}`;

// --- Trees, map, popup ------------------------------------------------------------------------------------------
export const TREE_NOT_FOUND = 'Tree not found';
export const VALIDATORS_UNREADABLE = 'Failed to fetch validators';
export const TREE_ID_COPIED = 'Copied in your clipboard';
export const TREE_ID_COPY_FAILED = 'Could not copy the tree ID';

// --- Validation and its queue -----------------------------------------------------------------------------------
export const WAITING_FOR_GPS = 'Waiting for sufficient GPS accuracy...';
export const DEBUG_GPS_WARNING = 'Debug mode: Allowing validation with insufficient GPS accuracy';
export const TREE_QUEUED = 'Tree was added to queue';
export const TREE_QUEUE_FAILED = 'Could not add tree to queue';
export const VALIDATION_REMOVED_FROM_QUEUE = 'Tree removed from queue';
export const treeSynced = (treeId: number | string) => `Tree #${treeId} synced successfully`;
export const treeSyncFailed = (treeId: number | string) => `Failed to sync tree #${treeId}`;
export const treeNotSynced = (treeId: number | string, reason: string) => `Could not sync tree id ${treeId}, ${reason}`;

// --- Moving trees -----------------------------------------------------------------------------------------------
export const NO_TREES_SELECTED = 'No trees selected';
export const TOO_MANY_TREES_SELECTED = 'You cannot move more trees than you have selected';
export const NO_TREES_MOVED = 'No trees were moved';
export const NO_CONTRACT_SELECTED = 'No contract selected';
export const treesMoved = (trees: number, contract: string | undefined) => `Moved ${trees} trees to contract ${contract}`;
export const MOVE_TREES_FAILED = 'Error while moving trees';

// --- Saving the trees offline -----------------------------------------------------------------------------------
export const TREES_LIST_SIZE_UNREADABLE = 'Could not read the size of the trees list';
export const NO_TREES_TO_DOWNLOAD = 'No trees to download with this filter';
export const OFFLINE_SAVE_APP_ONLY = 'Saving trees offline needs the app';
export const OFFLINE_SAVE_ALREADY_RUNNING = 'A save is already under way';
export const NO_TREES_TO_SAVE = 'No trees to save with this filter';
export const offlineSaved = (trees: number, bytes: string) => `Saved ${trees} trees, ${bytes} downloaded`;
export const offlineSaveDeviceFull = (saved: string) =>
  `${saved}. The device is full: the photos were stopped, the trees are complete`;
export const offlineSavePhotosFailed = (saved: string, photos: number) =>
  `${saved}. ${photos} photo${photos > 1 ? 's' : ''} could not be saved: press again to retry them`;
export const offlineSaveFailed = (reason: string) =>
  `The trees could not all be saved${reason ? `: ${reason}` : ': try again'}`;

// --- Download KML -----------------------------------------------------------------------------------------------
export const KML_SAVED = 'KML file saved in Download folder';
export const KML_DOWNLOAD_FAILED = 'Error downloading KML file';

// --- Planter form -----------------------------------------------------------------------------------------------
export const IMAGE_PROCESSING_FAILED = 'Failed to process image';
export const TREE_PROCESSING_FAILED = 'Failed to process tree';
export const GPS_COORDINATES_REQUIRED = 'GPS coordinates are required: please wait for GPS to be ready';

// --- Logs, clipboard, debug tools -------------------------------------------------------------------------------
export const SENDING_LOG = 'Sending the log…';
export const LOG_SENT = 'Log sent';
export const logNotSent = (status: number) => `The log was not sent (HTTP ${status})`;
export const LOG_SHARE_FALLBACK = 'Could not reach the server, opening the share page';
export const CONTENT_COPIED = 'Content copied to clipboard';
export const CONTENT_COPY_FAILED = 'Could not copy to clipboard';

// --- Login and admin --------------------------------------------------------------------------------------------
export const PASSWORD_CHANGED = 'Password has been changed successfully';
export const RESET_EMAIL_SENT = 'An email will be sent to you shortly';
export const CONTRACT_UPDATED = 'Contract updated';
export const CONTRACT_SAVE_FAILED = 'There was an error saving the contract';
export const CONTRACT_CREATED = 'Contract created sucessfully';
export const contractsUnreadable = (reason: string) => `could not retrieve contracts list: ${reason}`;
export const USER_CREATED = 'User created sucessfully';
